export default {
    isFormOpen: state => state.formIsOpen,
    isGridOpen: state => state.gridIsOpen,

    getDataTableOptions: state => state.dataTableOptions,
    getActions: state => state.actions,
    getRowActions: state => state.rowActions,
    getHeaderFields: state => state.headerFields
}
